import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { IoIosCheckmark as TickIcon } from 'react-icons/io';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';

import { useGame } from '../../../../context';
import { getRegionScoreDetails } from './selectors';

const useStyles = createUseStyles({
  details: {
    color: '#525252',
    composes: ['fs12', 'mb24', 'mt12'],
  },
  item: {
    composes: ['flex-columns', 'flex-between', 'items-center', 'mb6'],
  },
  label: {},
  score: {
    composes: ['text-center', 'fs10'],
    height: 24,
    lineHeight: 2.4,
    width: 60,
  },
  tick: {
    '&:not(.completed)': { color: '#202124' },
    composes: ['text-center'],
    height: 24,
    verticalAlign: 'middle',
  },
});

const sortByCompleted = (a, b) => {
  if (a.completed > b.completed) return 1;
  if (a.completed < b.completed) return -1;
  return 0;
};

const RegionItemssComponent = React.memo(({ id }) => {
  const classes = useStyles();
  const { collectibles, tags } = useGame();

  const percentages = useSelector(_ =>
    getRegionScoreDetails(_, id, collectibles, tags)
  );

  return (
    <div className={classes.details}>
      {tags
        .filter(tag => percentages[tag.id])
        .map(({ id: tagid, label }) => {
          const { completed, count, total } = percentages[tagid];
          return { completed, count, id: tagid, label, total };
        })
        .sort(sortByCompleted)
        .map(({ completed, count, id: tagid, label, total }) => (
          <div key={`${id}::${tagid}`} className={classes.item}>
            <div className={classes.label}>
              <TickIcon
                className={classnames(classes.tick, { completed })}
                size={22}
              />
              <span>{label}</span>
            </div>
            <div className={classes.score}>
              <span>{count}</span>
              <span>/</span>
              <span>{total}</span>
            </div>
          </div>
        ))}
    </div>
  );
});

RegionItemssComponent.propTypes = {
  id: PropTypes.string.isRequired,
};

RegionItemssComponent.displayName = 'RegionItemssComponent';

export default RegionItemssComponent;
